<template>
  <form
    @submit.prevent="submitZona"
    class="pl-8 pr-3 w-full h-full">
    <div class="flex flex-row items-center gap-3 mb-3">
      <button
        @click="setActiveSubMenu('ToolZones')"
        class="flex flex-row justify-center items-center w-4 h-4 bg-gray-400 rounded-md"
        title="Kembali ke list zona"
        type="button">
        <i class="material-icons text-lg text-white">chevron_left</i>
      </button>
      <h1 class="flex flex-col">
        <span class="text-sm text-white mr-1 font-bold">Tambah zona</span>
        <i class="text-xs text-white">(silahkan lengkapi form berikut untuk menambah zona)</i>
      </h1>
    </div>
    <div class="flex flex-col mb-3">
      <Message :message="message" />
      <div class="w-full mb-1">
        <label class="text-xs text-white">Title</label>
        <input
          class="w-full h-8 rounded-md text-xs text-gray-500"
          type="text"
          name="title"
          v-model="title">
      </div>
      <div class="w-full mb-1">
        <label class="text-xs text-white">Deskripsi</label>
        <textarea
          class="w-full h-12 rounded-md text-xs text-gray-500"
          type="text"
          name="description"
          v-model="description"></textarea>
      </div>
      <div class="w-full mb-1">
        <label class="text-xs text-white">Import file spasial (<i>.geojson</i>)</label>
        <div class="relative flex flex-row items-center w-full h-8 bg-white border border-gray-500 rounded-md">
          <span
            class="grow-1 w-full  z-0 px-3 text-xs text-gray-500"
            style="white-space: nowrap;overflow: hidden;">{{ file ? file.name : 'klik untuk pilih file' }}</span>
          <i class="material-icons flex z-0 justify-center items-center w-8 h-8 text-lg text-gray-500">upload_file</i>
          <input
            @change="selectFile($event)"
            class="absolute top-0 right-0 bottom-0 left-0 z-0 form-input w-full h-8 rounded-md text-xs opacity-0"
            type="file"
            name="file">
        </div>
      </div>
    </div>
    <div class="flex justify-end items-center gap-1 pt-3 border border-gray-400 border-r-0 border-b-0 border-l-0">
      <button
        @click="setActiveSubMenu('ToolZones')"
        class="px-1 py-1 w-24 h-8 bg-gray-400 rounded-md"
        type="button">
        <span class="text-xs text-white">Batal</span>
      </button>
      <button
        class="px-1 py-1 w-24 h-8 bg-green-500 rounded-md"
        type="submit">
        <span class="text-xs text-white">Simpan</span>
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Message from './Message.vue'

export default {
  name: 'ToolZoneNew',
  data: () => ({
    title: null,
    description: null,
    file: null
  }),
  computed: {
    ...mapGetters(['message'])
  },
  components: {
    Message
  },
  methods: {
    ...mapActions(['toAddZone']),
    ...mapMutations([
      'setActiveSubMenu',
      'setMessage'
    ]),
    selectFile: function (e) {
      this.file = e.target.files[0]

      try {
        if (this.file.size > 10485760) {
          this.setMessage({
            text: 'file tidak boleh lebih dari 10MB',
            status: 400
          })

          return
        }

        if (this.file.type === 'application/geo+json') {
          // file ok
        } else {
          this.setMessage({
            text: 'file yang di upload hanya boleh .geojson',
            status: 400
          })

          return
        }
      } catch (err) {
        this.setMessage({
          message: {
            text: 'silahkan pilih file terlebih dahulu!',
            status: 400
          }
        })

        return
      }
    },
    submitZona: async function (e) {
      const data = new FormData(e.target)

      await this.toAddZone(data)

      if (this.message.status === 200) {
        this.setActiveSubMenu('ToolZones')
      }
    }
  }
}
</script>
